<template>
  <div>
    <div v-if="data.company.notesByDepartment[data.departmentId]">
      <h6>Department: {{ departmentName }}</h6>
      <p v-html="data.company.notesByDepartment[data.departmentId]"></p>
    </div>
    <p v-else>No company notes found for {{ departmentName }}.</p>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {objectNameById} from 'src/utilities/utils'

  export default {
    props: ['data'],
    computed: {
      ...mapGetters({
        departments: 'departments/results'
      }),
      departmentName() {
        return objectNameById(this.departments, this.data.departmentId)
      }
    }
  }
</script>

